import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { underlyingFoldLargeSize } from '../../../data/underlying-fold-size';
import PriceContainer from './PriceContainer';
import TitleContainer from './TitleContainer/TitleContainer';

const useStyles = makeStyles((theme) => ({
  root: {
    marginLeft: 13,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    flex: 1,
    maxWidth: 180,

    [theme.breakpoints.up('md')]: {
      display: 'inline-block',
    },

    '&:first-child': {
      // eslint-disable-next-line no-useless-computed-key
      [`@media (max-width: ${underlyingFoldLargeSize}px)`]: {
        marginLeft: 0,
      },
    },

    // eslint-disable-next-line no-useless-computed-key
    [`@media (min-width: ${underlyingFoldLargeSize}px)`]: {
      marginLeft: 25,
    },
  },
}));

const ValueContainer = ({ symbol = '', label = '' }) => {
  const classes = useStyles();

  return (
    <div
      className={`${classes.root} underlying-value underlying-value--${symbol}`}
    >
      <PriceContainer symbol={symbol} />
      <TitleContainer symbol={symbol} label={label} />
    </div>
  );
};

export default ValueContainer;
